// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { InferenceSession as InferenceSessionImpl } from './inference-session-impl.js';
// eslint-disable-next-line @typescript-eslint/naming-convention
export const InferenceSession = InferenceSessionImpl;
//# sourceMappingURL=inference-session.js.map